import { Component, Input } from '@angular/core';

import { CardOptions } from './card-options.interface';

/**
 * This component can be used for fixed sized cards, having the centered content something like ticker.
 * 
 * This can be used as:
 * 
 * <ac-card-wrapper>
 * 	<span>MALOX</span>
 * </ac-card-wrapper>
 * 
 * <ac-card-wrapper>
 * 	<span dcrHTMLKey="XX">XYZ</span>
 * </ac-card-wrapper>
 * 
 * This is using daisy's dz-card 
 */

@Component({
	selector: 'ac-card-wrapper',
	templateUrl: './card-wrapper.component.html',
	styleUrls: ['./card-wrapper.component.scss']
})
export class CardWrapperComponent {
	@Input() public cardOptions: CardOptions = {};
}
